var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	51354: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(11817), __webpack_require__.e(36124), __webpack_require__.e(33927)]).then(() => (() => (__webpack_require__(33927))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	62863: {
		fallback: () => (Promise.all([__webpack_require__.e(95361), __webpack_require__.e(73393)]).then(() => (() => (__webpack_require__(73393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	303: {
		fallback: () => (Promise.all([__webpack_require__.e(95361), __webpack_require__.e(23620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	30046: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(82199)]).then(() => (() => (__webpack_require__(82199))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	43531: {
		fallback: () => (Promise.all([__webpack_require__.e(30046), __webpack_require__.e(50006), __webpack_require__.e(94967), __webpack_require__.e(80436)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	50006: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(16613)]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	81380: {
		fallback: () => (Promise.all([__webpack_require__.e(51354), __webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(16450), __webpack_require__.e(81383)]).then(() => (() => (__webpack_require__(81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",
	},
	89418: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(30046), __webpack_require__.e(43531), __webpack_require__.e(46264), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	16450: {
		fallback: () => (Promise.all([__webpack_require__.e(11817), __webpack_require__.e(49074)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	2140: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(30046), __webpack_require__.e(50006), __webpack_require__.e(36351), __webpack_require__.e(59868), __webpack_require__.e(390), __webpack_require__.e(35741)]).then(() => (() => (__webpack_require__(35741))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/flags",
	},
	59868: {
		fallback: () => (Promise.all([__webpack_require__.e(30046), __webpack_require__.e(50006), __webpack_require__.e(89418), __webpack_require__.e(81380), __webpack_require__.e(43531), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(16450), __webpack_require__.e(99803), __webpack_require__.e(76041), __webpack_require__.e(11817), __webpack_require__.e(46264), __webpack_require__.e(36712), __webpack_require__.e(36124), __webpack_require__.e(99737), __webpack_require__.e(45213)]).then(() => (() => (__webpack_require__(45213))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/utils",
	},
	63880: {
		fallback: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(13334))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/global-environments",
	},
	75908: {
		fallback: () => (__webpack_require__.e(34456).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	83436: {
		fallback: () => (Promise.all([__webpack_require__.e(94967), __webpack_require__.e(30161)]).then(() => (() => (__webpack_require__(30161))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",
	},
	20402: {
		fallback: () => (Promise.all([__webpack_require__.e(30046), __webpack_require__.e(2140), __webpack_require__.e(81897)]).then(() => (() => (__webpack_require__(81897))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/access-control",
	},
	26764: {
		fallback: () => (Promise.all([__webpack_require__.e(20946), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(63450))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/state/route",
	},
	16900: {
		fallback: () => (Promise.all([__webpack_require__.e(64690), __webpack_require__.e(50006)]).then(() => (() => (__webpack_require__(64690))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",
	},
	97470: {
		fallback: () => (Promise.all([__webpack_require__.e(93482), __webpack_require__.e(12587)]).then(() => (() => (__webpack_require__(12587))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",
	},
	20946: {
		fallback: () => (Promise.all([__webpack_require__.e(51354), __webpack_require__.e(303), __webpack_require__.e(89418), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(32175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",
	},
	99737: {
		fallback: () => (__webpack_require__.e(66231).then(() => (() => (__webpack_require__(66231))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-device-detector",
	},
	17548: {
		fallback: () => (Promise.all([__webpack_require__.e(30046), __webpack_require__.e(43531), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(59868), __webpack_require__.e(99803), __webpack_require__.e(26690), __webpack_require__.e(93482), __webpack_require__.e(24499), __webpack_require__.e(68656), __webpack_require__.e(55970), __webpack_require__.e(35123)]).then(() => (() => (__webpack_require__(35123))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/auth",
	},
	43604: {
		fallback: () => (Promise.all([__webpack_require__.e(30046), __webpack_require__.e(63880), __webpack_require__.e(76041), __webpack_require__.e(24499), __webpack_require__.e(92434), __webpack_require__.e(99492)]).then(() => (() => (__webpack_require__(99492))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/common",
	},
	21672: {
		fallback: () => (Promise.all([__webpack_require__.e(16450), __webpack_require__.e(85114)]).then(() => (() => (__webpack_require__(85114))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular-auth-oidc-client",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"303": [
		303
	],
	"2140": [
		2140
	],
	"16450": [
		16450
	],
	"17548": [
		17548
	],
	"20946": [
		20946
	],
	"22322": [
		43604
	],
	"30046": [
		30046
	],
	"43531": [
		43531
	],
	"50006": [
		50006
	],
	"51354": [
		51354
	],
	"55970": [
		21672
	],
	"59868": [
		59868
	],
	"62863": [
		62863
	],
	"62891": [
		20402,
		26764
	],
	"63880": [
		63880
	],
	"68656": [
		16900,
		97470
	],
	"81380": [
		81380
	],
	"89418": [
		89418
	],
	"99737": [
		99737
	],
	"99803": [
		75908,
		83436
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}